import React from 'react';
import { Button } from '../../atoms/button/index.ts';
import { PageLayout } from '../../atoms/page-layout';

const AdminDashboard = function AdminDashboard() {
    return (
        <PageLayout>
            <h1 className=" typography-title-2 layout-spacing-bottom">Admin Dashboard</h1>
            <div className="layout-grouping-children layout-grouping-children--large">
                <div className="layout-grouping-children">
                    <Button
                        id="top-monthly-charities"
                        appearance="primary"
                        href="/Admin/Givings/Total?page=1&pagesize=20"
                    >
                        Top Monthly Charities
                    </Button>
                    <Button
                        id="donor-breakdown-by-chart"
                        appearance="primary"
                        href="/Admin/Giving/Donors?page=1&pagesize=20"
                    >
                        Donor Breakdown by Charity
                    </Button>
                </div>
                <div className="layout-grouping-children">
                    <Button
                        id="charity-list"
                        appearance="primary"
                        href="/Admin/Charity/List"
                    >
                        Charity List
                    </Button>
                    <Button
                        id="paypal-charity-management"
                        appearance="primary"
                        href="/Admin/PayPal/Manage"
                    >
                        PayPal Charity Management
                    </Button>
                    <Button
                        id="reassign-user-to-a-new-charity"
                        appearance="primary"
                        href="/Admin/User/ReassignUserClaims"
                    >
                        Reassign User to a new Charity
                    </Button>
                    <Button
                        id="stripe-customer-list"
                        appearance="primary"
                        href="/Admin/StripeToken/List"
                    >
                        Stripe Customer List
                    </Button>
                    <Button
                        id="donors-payment-options"
                        appearance="primary"
                        href="/Portal/Donors/PaymentOptions/List"
                    >
                        Donors Payment Options
                    </Button>
                    <Button
                        id="reconciliation-legacy"
                        appearance="primary"
                        href="/Admin/Reconciliation/Legacy"
                    >
                        Reconciliation Legacy
                    </Button>
                </div>
                <div className="layout-grouping-children">
                    <Button
                        id="migration"
                        appearance="primary"
                        href="/Admin/Migration"
                        target="_blank"
                    >
                        Migration
                    </Button>
                    <Button
                        id="check-verification-status-change"
                        appearance="primary"
                        href="/Admin/Charity/CheckCharityStatuses"
                    >
                        Check verification Status Change
                    </Button>
                    <Button
                        id="check-connect-balances"
                        appearance="primary"
                        href="/Admin/Charity/CheckBalance"
                    >
                        Check Connect Balances
                    </Button>
                    <Button
                        id="scheduled-job-list"
                        appearance="primary"
                        href="/Admin/Manage/Schedule/List"
                    >
                        Scheduled Job List
                    </Button>
                    <Button
                        id="background-job-monitor"
                        appearance="primary"
                        href="/Admin/Manage/BackgroundJob"
                    >
                        Background Job Monitor
                    </Button>
                </div>
            </div>
        </PageLayout>
    );
};

export default AdminDashboard;
